export default __webpack_public_path__ + "static/media/catalog.2ab2cc82.svg";